/* ===========================================================
   1) BEAUTY BAG OMAGGIO SOPRA 79€
   =========================================================== */
(function() {
  const GIFT_VARIANT_ID = 56468224835929;        // variante Beauty Bag omaggio
  const THRESHOLD_CENTS = 7900;                  // 79€ in centesimi

  async function getCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return res.json();
  }

  async function cartAdd(variantId, qty, props) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: qty,
        properties: props || {}
      })
    });
  }

  async function cartChange(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ line, quantity: qty })
    });
  }

  function updateBeautyBanner(hasGift, subtotal) {
    const reachedThreshold = subtotal >= THRESHOLD_CENTS;
    let banner = document.getElementById('beauty-bag-banner');
    const shouldShow = hasGift && reachedThreshold;

    if (!shouldShow) {
      if (banner) banner.remove();
      return;
    }

    if (!banner) {
      banner = document.createElement('div');
      banner.id = 'beauty-bag-banner';
      banner.textContent = 'Hai ottenuto la Beauty Bag in omaggio ✨';
      banner.style.position = 'relative';
      banner.style.marginTop = '8px';
      banner.style.padding = '8px 14px';
      banner.style.borderRadius = '999px';
      banner.style.fontSize = '13px';
      banner.style.fontWeight = '600';
      banner.style.textAlign = 'center';
      banner.style.background = '#f7f4f4';
      banner.style.border = '1px solid rgba(0,0,0,.08)';
      banner.style.color = '#111';
    }

    const target = document.querySelector('.cart__footer, .cart__ctas, .cart-drawer__footer, .cart-drawer__inner') || document.body;
    if (!banner.parentNode || banner.parentNode !== target) {
      target.appendChild(banner);
    }
  }

  async function syncGift() {
    try {
      const cart = await getCart();
      const subtotal = cart.items_subtotal_price; // centesimi

      const idx = cart.items.findIndex(i => i.variant_id === GIFT_VARIANT_ID);
      const hasGift = idx !== -1;
      const giftLine = hasGift ? (idx + 1) : null;
      const giftQty  = hasGift ? cart.items[idx].quantity : 0;

      // aggiorna banner beauty bag
      updateBeautyBanner(hasGift, subtotal);

      // 1) Soglia raggiunta -> assicurati che la gift ci sia (qty=1)
      if (subtotal >= THRESHOLD_CENTS && !hasGift) {
        await cartAdd(GIFT_VARIANT_ID, 1, { _auto_gift: 'true' });
        location.reload();
        return;
      }

      // 2) Sotto soglia -> rimuovi la gift se presente
      if (subtotal < THRESHOLD_CENTS && hasGift) {
        await cartChange(giftLine, 0);
        location.reload();
        return;
      }

      // 3) Hard cap: se qualcuno prova a mettere qty>1, riportala a 1
      if (hasGift && giftQty > 1) {
        await cartChange(giftLine, 1);
        location.reload();
        return;
      }
    } catch (e) {
      console.error('Gift sync error', e);
    }
  }

  // BLOCK: intercetta click al prodotto Beauty Bag e reindirizza al carrello
  document.addEventListener('click', function(e) {
    const a = e.target.closest('a[href*="/products/beauty-bag"]');
    if (a) {
      e.preventDefault();
      window.location.href = '/cart';
    }
  });

  // BLOCK: se qualcuno prova ad aggiungere direttamente la variante regalo
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    const idInput = form.querySelector('input[name="id"]');
    if (idInput && Number(idInput.value) === GIFT_VARIANT_ID) {
      e.preventDefault();
      alert('Questo omaggio si aggiunge automaticamente con ordini da 79€.');
      return false;
    }
  });

  // Sync su load e su cambi carrello
  document.addEventListener('DOMContentLoaded', syncGift);

  document.addEventListener('cart:updated', () => {
    setTimeout(syncGift, 300);
  });

  document.addEventListener('change', () => {
    setTimeout(syncGift, 600);
  });

  document.addEventListener('click', function(e){
    const btn = e.target.closest(
      'form[action*="/cart/add"] [type="submit"], button[name="add"], button.add-to-cart'
    );
    if (btn) setTimeout(syncGift, 800);
  });

  // Esponi la funzione per l’altro IIFE
  window.__syncBeautyGift = syncGift;
})();

/* ===========================================================
   2) PATCH BEAUTY BAG: PRIMA DEL CHECKOUT
   =========================================================== */
(function() {
  const GIFT_VARIANT_ID = 56468224835929;
  const THRESHOLD_CENTS = 7900;

  async function getCart() {
    const r = await fetch('/cart.js', { headers: {'Accept':'application/json'} });
    return r.json();
  }

  async function cartChange(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ line, quantity: qty })
    });
  }

  // 1) Wrapper su fetch: ogni volta che il carrello cambia, rieseguo il sync
  const _origFetch = window.fetch;
  window.fetch = async function(input, init) {
    const res = await _origFetch(input, init);
    try {
      const url = (typeof input === 'string' ? input : input.url) || '';
      if (url.includes('/cart/add.js') || url.includes('/cart/change.js') || url.includes('/cart/update.js')) {
        setTimeout(() => document.dispatchEvent(new CustomEvent('cart:updated')), 120);
      }
    } catch(e){}
    return res;
  };

  // 2) Dopo click su rimuovi/meno, risincronizza
  document.addEventListener('click', (e) => {
    const willChangeCart = e.target.closest(
      '[data-cart-remove], .cart-remove, .cart__remove, button[name="remove"], a[href*="change?line"], .quantity__button[name="minus"], button[name="minus"]'
    );
    if (willChangeCart) {
      setTimeout(() => document.dispatchEvent(new CustomEvent('cart:updated')), 150);
    }
  });

  // 3) Prima del checkout, assicurati che la gift non resti se sotto soglia
  async function ensureGiftBeforeCheckout() {
    try {
      const cart = await getCart();
      const subtotal = cart.items_subtotal_price;
      const idx = cart.items.findIndex(i => i.variant_id === GIFT_VARIANT_ID);
      if (idx !== -1 && subtotal < THRESHOLD_CENTS) {
        await cartChange(idx + 1, 0);
      }
    } catch(e) {
      console.warn('ensureGiftBeforeCheckout error', e);
    } finally {
      window.location.href = '/checkout';
    }
  }

  // Intercetta i bottoni checkout
  document.addEventListener('click', (e) => {
    const checkoutBtn = e.target.closest(
      'button[name="checkout"], [data-checkout-button], a[href="/checkout"], form[action="/cart"] [name="checkout"]'
    );
    if (checkoutBtn) {
      e.preventDefault();
      checkoutBtn.disabled = true;
      ensureGiftBeforeCheckout();
    }
  });

  // Quando il carrello viene aggiornato, richiama la sync della bag (se esiste)
  document.addEventListener('cart:updated', () => {
    if (typeof window.__syncBeautyGift === 'function') {
      setTimeout(window.__syncBeautyGift, 50);
    }
  });
})();

/* ===========================================================
   3) DISCHETTI OMAGGIO CON LE 3 COMBO
   =========================================================== */
(function() {
  // Variante CLONE dei dischetti omaggio (quella che va gratuita)
  const DISCHETTI_VARIANT_ID = 56700339388761;

  // Varianti delle combo (Timeless Glow, Plump & Protect, Daily Defense Kit)
  const COMBO_VARIANTS = [
    56454203310425, // Timeless Glow
    56454261768537, // Plump & Protect
    56454250824025  // Daily Defense Kit
  ];

  let syncingDischetti = false;

  async function getCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return res.json();
  }

  async function cartAdd(variantId, qty, props) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: qty,
        properties: props || {}
      })
    });
  }

  async function cartChange(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ line, quantity: qty })
    });
  }

  function updateDischettiBanner(hasGift, hasCombo) {
    let banner = document.getElementById('combo-gift-banner');
    const shouldShow = hasGift && hasCombo;

    if (!shouldShow) {
      if (banner) banner.remove();
      return;
    }

    if (!banner) {
      banner = document.createElement('div');
      banner.id = 'combo-gift-banner';
      banner.textContent = 'Hai ottenuto i dischetti in omaggio con la tua combo ✨';
      banner.style.position = 'relative';
      banner.style.marginTop = '12px';
      banner.style.padding = '10px 14px';
      banner.style.borderRadius = '999px';
      banner.style.fontSize = '13px';
      banner.style.fontWeight = '600';
      banner.style.textAlign = 'center';
      banner.style.background = '#f7f4f4';
      banner.style.border = '1px solid rgba(0,0,0,.08)';
      banner.style.color = '#111';
    }

    const target = document.querySelector('.cart__footer, .cart__ctas, .cart-drawer__footer, .cart-drawer__inner') || document.body;
    if (!banner.parentNode || banner.parentNode !== target) {
      target.appendChild(banner);
    }
  }

  async function syncDischetti() {
    if (syncingDischetti) return;
    syncingDischetti = true;

    try {
      const cart = await getCart();

      // Quante combo ci sono?
      const comboQty = cart.items.reduce((sum, item) => {
        return sum + (COMBO_VARIANTS.includes(item.variant_id) ? item.quantity : 0);
      }, 0);
      const hasCombo = comboQty > 0;

      // Trova i dischetti omaggio
      const idx = cart.items.findIndex(item => item.variant_id === DISCHETTI_VARIANT_ID);
      const hasGift = idx !== -1;
      const giftLine = hasGift ? idx + 1 : null;
      const giftQty  = hasGift ? cart.items[idx].quantity : 0;

      // Aggiorna banner dischetti
      updateDischettiBanner(hasGift, hasCombo);

      // 1) Combo presente, gift assente → aggiungi 1
      if (hasCombo && !hasGift) {
        await cartAdd(DISCHETTI_VARIANT_ID, 1, { _combo_gift: 'true' });
        location.reload();
        return;
      }

      // 2) Nessuna combo ma gift presente → rimuovi
      if (!hasCombo && hasGift) {
        await cartChange(giftLine, 0);
        location.reload();
        return;
      }

      // 3) Hard cap: mai più di 1 dischetto omaggio → forza qty=1 e ricarica
      if (hasGift && giftQty > 1) {
        await cartChange(giftLine, 1);
        location.reload();
        return;
      }

    } catch (err) {
      console.error('Errore sync dischetti omaggio:', err);
    } finally {
      syncingDischetti = false;
    }
  }

  // Blocca aggiunta manuale del prodotto omaggio (clone)
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    const idInput = form.querySelector('input[name="id"]');
    if (idInput && Number(idInput.value) === DISCHETTI_VARIANT_ID) {
      e.preventDefault();
      alert('Questo prodotto si aggiunge in omaggio con le combo selezionate ✨');
    }
  });

  // Se qualcuno apre un link diretto con ?variant=DISCHETTI_VARIANT_ID → manda al carrello
  document.addEventListener('click', function(e) {
    const sel = 'a[href*="variant=' + DISCHETTI_VARIANT_ID + '"]';
    const a = e.target.closest(sel);
    if (a) {
      e.preventDefault();
      window.location.href = '/cart';
    }
  });

  // Esegui quando la pagina è pronta
  document.addEventListener('DOMContentLoaded', syncDischetti);

  // Esegui ad ogni aggiornamento carrello (evento già gestito sopra)
  document.addEventListener('cart:updated', () => {
    setTimeout(syncDischetti, 200);
  });
})();
